function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "noun_Refresh_2620658");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.7
}, React.createElement("g", {
  id: "3.2-reporting-opt-3",
  transform: "translate(-938.000000, -247.000000)",
  fill: "#636363"
}, React.createElement("g", {
  id: "noun_Refresh_2620658",
  transform: "translate(938.000000, 247.000000)"
}, React.createElement("path", {
  d: "M8.22153846,0 C10.4861538,0 12.5046154,0.935384615 13.9815385,2.41230769 L15.9015385,1.32923077 L15.9015385,6.64615385 L11.2738462,3.98769231 L12.8,3.10153846 C11.6184615,1.96923077 9.99384615,1.32923077 8.22153846,1.32923077 C4.57846154,1.32923077 1.62461538,4.23384615 1.52615385,7.87692308 L0.246153846,7.87692308 C0.344615385,3.49538462 3.88923077,0 8.22153846,0 Z M0.344615385,8.71384615 L4.92307692,11.7661538 L3.29846154,12.5538462 C4.52923077,13.8830769 6.30153846,14.72 8.22153846,14.72 C11.9138462,14.72 14.9169231,11.7169231 14.9169231,8.02461538 L14.9169231,7.82769231 L16.2461538,7.82769231 C16.2461538,7.87692308 16.2461538,7.97538462 16.2461538,8.02461538 C16.2461538,12.4061538 12.6523077,16 8.22153846,16 C5.76,16 3.59384615,14.8676923 2.11692308,13.1446154 L0,14.1784615 L0.344615385,8.71384615 Z",
  id: "Shape"
}))));

var SvgIconRefresh = function SvgIconRefresh(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconRefresh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-refresh.e4484b0a.svg";
export { ForwardRef as ReactComponent };